"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const js_buildTransaction_1 = require("./js-buildTransaction");
const logic_1 = require("./logic");
const getFeesForTransaction = ({ account, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    const walletTx = yield (0, js_buildTransaction_1.buildTransaction)(account, transaction);
    const fees = new bignumber_js_1.BigNumber(walletTx.fee).integerValue();
    let txInputs = walletTx.inputs.map(i => {
        return {
            address: i.address,
            value: new bignumber_js_1.BigNumber(i.value),
            previousTxHash: i.output_hash,
            previousOutputIndex: i.output_index,
        };
    });
    let txOutputs = walletTx.outputs.map(o => {
        return {
            outputIndex: walletTx.outputs.indexOf(o),
            address: o.address,
            isChange: o.isChange,
            value: new bignumber_js_1.BigNumber(o.value),
            hash: undefined,
            blockHeight: undefined,
            rbf: transaction.rbf,
        };
    });
    const perCoin = logic_1.perCoinLogic[account.currency.id];
    if (perCoin) {
        const { syncReplaceAddress } = perCoin;
        if (syncReplaceAddress) {
            txInputs = txInputs.map(i => (Object.assign(Object.assign({}, i), { address: i.address && syncReplaceAddress(i.address) })));
            txOutputs = txOutputs.map(o => (Object.assign(Object.assign({}, o), { address: o.address && syncReplaceAddress(o.address) })));
        }
    }
    return {
        fees,
        txInputs,
        txOutputs,
    };
});
exports.default = getFeesForTransaction;
//# sourceMappingURL=js-getFeesForTransaction.js.map